import {toast, ToastOptions} from 'react-toastify';

type TProps = ToastOptions & {
  message: string;
};

export const showToast = ({message, ...props}: TProps) => {
  toast(message, props);
};
